module.exports = __webpack_public_path__ + "static/media/Warning.c3cbb701.mp3";